import * as fromActionTypes from './action-types.actions';
import { actionTypesAdapter, ActionTypesState, initialState } from './action-types.interfaces';

export function reducer(
  state: ActionTypesState = initialState,
  action: fromActionTypes.ActionTypesAction
): ActionTypesState {
  switch (action.type) {
    case fromActionTypes.GET_ACTION_TYPES_FROM_SERVER_SUCCESS: {
      return {
        ...actionTypesAdapter.addMany(action.payload.actionTypes, state)
      };
    }

    default: {
      return state;
    }
  }
}
